import React from "react";
import { useParams } from "react-router-dom";
import { SpaceContext } from "../../contexts/SpaceContext";
import { ProcessContext } from "../../contexts/ProcessContext";
import Spaces from "./components/Spaces";
import ProjectTable from "../tables/ProjectTable";

// Create the component
export function TenantSpaces() {
  const { tenantId } = useParams();
  const personalTenantId = localStorage.getItem("user") ?? "";
  const { setSpace } = React.useContext(SpaceContext);
  const { setProcess } = React.useContext(ProcessContext);
  // Add state for selected space
  const [selectedSpaceId, setSelectedSpaceId] = React.useState<string>("");

  // Reset space and process when this component mounts
  React.useEffect(() => {
    setSpace({ cSpaceId: "", cSpaceName: "" });
    setProcess({ cProcessId: "", cProcessName: "" });
  }, [setSpace, setProcess]);

  // Handle space selection with toggle functionality
  const handleSpaceClick = (spaceId: string) => {
    // If clicking the already selected space, deselect it
    if (selectedSpaceId === spaceId) {
      setSelectedSpaceId("");
      setSpace({ cSpaceId: "", cSpaceName: "" });
    } else {
      // Otherwise select the new space
      setSelectedSpaceId(spaceId);
      setSpace({ cSpaceId: spaceId, cSpaceName: "" });
    }
  };

  const isMembershipHome = !tenantId;

  return (
    <div>
      <Spaces
        createTenantId={personalTenantId}
        tenantId={tenantId}
        onSelectSpace={handleSpaceClick}
        selectedSpaceId={selectedSpaceId}
      />
      <div style={{ marginTop: "16px" }}>
        {selectedSpaceId ? (
          <ProjectTable id={selectedSpaceId} cyclesBy="SPACE" />
        ) : isMembershipHome ? (
          <p style={{ margin: "8px 0", color: "#666" }}>
            Select a space to view its projects.
          </p>
        ) : (
          <ProjectTable id={tenantId || ""} cyclesBy="TENANT" />
        )}
      </div>
    </div>
  );
}

export default TenantSpaces;
